import { initAutomaticListSyncRefresh } from './lists-details/automatic-list-sync-refresh.js';
import { initManualCardEditFlow } from './lists-manual-order/manual-card-edit-flow.js';
import { initManualGamesBrowser } from './lists-manual-order/manual-games-browser.js';
import { initManualListDeleteFlow } from './lists-manual-order/manual-list-delete-flow.js';

(function () {
    initListDetailsPage();
})();

export function initListDetailsPage(
    documentRef = globalThis.document,
    fetchImpl = globalThis.fetch,
    windowRef = globalThis.window,
    timerApi = globalThis,
) {
    initManualListDeleteFlow(documentRef, fetchImpl);
    const manualGamesBrowserController = initManualGamesBrowser(documentRef, fetchImpl, windowRef, timerApi);
    initManualCardEditFlow(documentRef, fetchImpl, manualGamesBrowserController, timerApi);
    initAutomaticListSyncRefresh(documentRef, windowRef);
}
